import { appstr } from "../utils/appstr";
import { QAlert } from "./QAlert";
import { QRFC } from "./QRFC";

export class QUpdatePlansRFC extends QRFC {
  constructor() {
    super();
  }

  InitUpdatePlans(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user, mode, data) {
    this.fMode = mode;
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
  }

  DoTransactionComplete(response, callBackObj) {
    var wsMgr = callBackObj.fWSMgr ?? callBackObj;
    var planMgr = wsMgr.fPlanManager;
    var r = JSON.parse(response);
    var success = r["success"];

    if (success) {
      if (planMgr) planMgr.SetIsRecalculatingFormulas(r["recalculatingFormulas"] === true);
      if (r["reloadplans"]) {
        callBackObj.fPlanInfo = r["data"];
        callBackObj.UpdatePanel();

        if (r["message"]) {
          var alert = new QAlert();
          alert.InitAlert(appstr("Alert"), r["message"], null, wsMgr);
        }
      } else {
        if (r["planMeta"]) {
          var planMeta = r["planMeta"];
          if (
            planMgr != null &&
            planMgr.fPlanInfo != null &&
            planMeta["ID"] == planMgr.fPlanInfo["ID"]
          ) {
            planMgr.fPlanInfo = planMeta;
            planMgr.UpdateContext();
            wsMgr.UpdateDocContext();
          }
        }
      }
    } else {
      var alert = new QAlert();
      alert.InitAlert(
        appstr("Unable to Save Changes"),
        appstr("SystemError") +
          "\n" +
          appstr("Error") +
          ": " +
          "'" +
          r["message"] +
          "'" +
          ", Code: " +
          r["code"],
        null,
        wsMgr
      );
    }

    if (callBackObj.onResult) callBackObj.onResult(success, r);
  }
}
